"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3845],{

/***/ 34435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArticleCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);









var ArticleCard = function(param) {
    var imageUrl = param.imageUrl, title = param.title, url = param.url, description = param.description, articleCreateDate = param.articleCreateDate, _slotProps = param.slotProps, slotProps = _slotProps === void 0 ? {} : _slotProps;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    // remove the <p> tag from the description
    var previewDescription = description ? "".concat(description.replace(/<\/?p>/gi, ""), "...") : null;
    var articleDate = articleCreateDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        dateTime: articleCreateDate,
        useOrdinalDay: false,
        useLongMonth: true,
        useFullDate: true
    }) : null;
    var amplitudeEventCardClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Clicked Article Carousel"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.link), {
            onClick: amplitudeEventCardClick,
            href: url,
            target: !isSmallViewport ? "_blank" : "_self",
            variant: "link2",
            sx: function(theme) {
                return {
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                        cursor: "pointer",
                        textDecoration: "none"
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.image), {
                    mb: {
                        xs: 1,
                        sm: 2
                    },
                    borderRadius: "24px",
                    component: "img",
                    src: imageUrl,
                    alt: title,
                    loading: "lazy"
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.title), {
                            component: "h3",
                            variant: "h3",
                            mb: 1,
                            children: he__WEBPACK_IMPORTED_MODULE_1___default().decode(title)
                        })),
                        previewDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.description), {
                            component: "p",
                            variant: isLargeViewport ? "body2" : "body3",
                            color: "text.secondary",
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_10___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(articleDate ? "".concat(articleDate, " - ").concat(previewDescription) : previewDescription))
                            }
                        }))
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 83845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleSection": function() { return /* binding */ ArticleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35129);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);
/* harmony import */ var _components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34435);






var ArticleSection = function(param) {
    var articles = param.articles;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)().isSmallViewport;
    var segmentNameSingular = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNameSingular;
    if (articles.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        maxWidth: "lg",
        sx: {
            pt: {
                xs: 4,
                sm: 0
            },
            mb: {
                xs: 6,
                md: 12
            },
            mt: {
                sm: 6,
                md: 12
            },
            position: "relative",
            px: {
                xl: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                component: "h2",
                variant: isSmallViewport ? "h1" : "display3",
                mb: {
                    xs: 4,
                    sm: 6
                },
                mt: 0,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .l, {
                controlVariant: isSmallViewport ? "none" : "topRight",
                showProgressIndicator: isSmallViewport,
                itemsPerView: isSmallViewport ? 1 : 3,
                children: articles.map(function(article) {
                    var ref;
                    if (!((ref = article.largeImage) === null || ref === void 0 ? void 0 : ref.imageUrl)) return null;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__/* .ArticleCard */ .T, {
                        url: article.url,
                        imageUrl: article.largeImage.imageUrl,
                        title: article.title,
                        description: article.description,
                        articleCreateDate: article.createDate
                    }, article.title);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticleSection);


/***/ }),

/***/ 35129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46237);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87688);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19957);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98820);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96373);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54743);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);










var Carousel = function(param) {
    var children = param.children, _controlVariant = param.controlVariant, controlVariant = _controlVariant === void 0 ? "none" : _controlVariant, _showProgressIndicator = param.showProgressIndicator, showProgressIndicator = _showProgressIndicator === void 0 ? false : _showProgressIndicator, _itemGap = param.itemGap, itemGap = _itemGap === void 0 ? 3 : _itemGap, _itemsPerView = param.itemsPerView, itemsPerView = _itemsPerView === void 0 ? 3 : _itemsPerView, slotProps = param.slotProps;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var originalSlides = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    var totalSteps = originalSlides.length;
    var slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides));
    var gapInPixels = parseInt(theme.spacing(itemGap), 10);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(totalSteps), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTransitioning = ref1[0], setIsTransitioning = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), slideOffset = ref2[0], setSlideOffset = ref2[1];
    var touchStartX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var touchEndX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!containerRef.current) return undefined;
        var resizeObserver = new ResizeObserver(function(entries) {
            var ref;
            var containerWidth = entries[0].contentRect.width;
            var itemWidth = (containerWidth - (itemsPerView - 1) * gapInPixels) / itemsPerView;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.style.setProperty("--item-width", "".concat(itemWidth, "px"));
            setSlideOffset(itemWidth + gapInPixels);
        });
        resizeObserver.observe(containerRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        itemsPerView,
        gapInPixels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isTransitioning) return undefined;
        var timer = setTimeout(function() {
            setIsTransitioning(false);
            // When we reach the third set, jump back to equivalent position in second set
            if (currentSlide >= totalSteps * 2) {
                setCurrentSlide(currentSlide - totalSteps);
            }
            // When we reach the first set, jump to equivalent position in second set
            if (currentSlide < totalSteps) {
                setCurrentSlide(currentSlide + totalSteps);
            }
        }, 300);
        return function() {
            clearTimeout(timer);
        };
    }, [
        currentSlide,
        isTransitioning,
        totalSteps
    ]);
    var amplitudeEventButtonClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Rotate Article Carousel"
        });
    };
    var goToNextSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr + 1;
            return newSlide;
        });
    };
    var goToPrevSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr - 1;
            return newSlide;
        });
    };
    var handleTouchStart = function(e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function(e) {
        var ref;
        var ref1;
        var endX = (ref1 = (ref = e.changedTouches[0]) === null || ref === void 0 ? void 0 : ref.clientX) !== null && ref1 !== void 0 ? ref1 : 0;
        if (Math.abs(touchStartX.current - endX) > 50) {
            if (touchStartX.current - endX > 0) {
                goToNextSlide();
            } else {
                goToPrevSlide();
            }
        }
        touchStartX.current = 0;
        touchEndX.current = 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        alignItems: "center",
        children: [
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mr: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToPrevSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: containerRef,
                sx: {
                    "--item-width": "auto",
                    position: "relative",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        onTouchStart: handleTouchStart,
                        onTouchEnd: handleTouchEnd,
                        sx: {
                            display: "flex",
                            overflow: "hidden",
                            width: "100%"
                        }
                    }, slotProps), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                transform: "translateX(-".concat(currentSlide * slideOffset, "px)"),
                                transition: isTransitioning ? "transform 0.3s ease-in-out" : "none"
                            },
                            children: slides.map(function(slide, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    "aria-hidden": index < currentSlide || index > currentSlide + itemsPerView - 1,
                                    sx: {
                                        width: "var(--item-width)",
                                        flexShrink: 0,
                                        mr: index === slides.length - 1 ? 0 : itemGap,
                                        "& img": {
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "cover",
                                            display: "block",
                                            maxWidth: "100%",
                                            aspectRatio: "3/2"
                                        },
                                        p: 1
                                    },
                                    children: slide
                                }, "carousel-slide-".concat(index + 1));
                            })
                        })
                    })),
                    controlVariant === "topRight" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end",
                            position: "absolute",
                            top: "-85px",
                            right: "0",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    mr: 2
                                },
                                onClick: goToPrevSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                onClick: goToNextSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            })
                        ]
                    }),
                    showProgressIndicator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            mt: {
                                xs: 2,
                                md: 6
                            },
                            "& ul .dot": {
                                height: "5px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            stepNumber: currentSlide % totalSteps + 1,
                            totalSteps: totalSteps
                        })
                    })
                ]
            }),
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ml: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToNextSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ })

}]);